// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "primeui." + {"241":"c67c8800715bab62e38b","466":"46713e76bb826d0d7ff3","483":"cbf59c6c306520e31a17","620":"5159dc4024049c73f035","721":"23189616759ac1141937","726":"ffc23368c31acf3c8030","755":"6f8330c4f3a47342b59c"}[chunkId] + ".css";
};